module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }